/* Keep Venue's native drawer and focus management; close it for same-page links. */
(() => {
  if (document.documentElement.dataset.sjNavigationReady === 'true') return;
  document.documentElement.dataset.sjNavigationReady = 'true';
  document.addEventListener('click', async event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('#modal-main-menu a[href]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) return;
    let id;
    try { id = decodeURIComponent(url.hash.slice(1)); } catch { return; }
    const target = document.getElementById(id);
    const dialog = link.closest('#modal-main-menu');
    if (!target || !dialog || typeof dialog.close !== 'function') return;
    event.preventDefault();
    // Venue resolves close() after the drawer animation and native focus return.
    await dialog.close();
    if (window.location.hash !== url.hash) {
      window.history.pushState(null, '', `${url.pathname}${url.search}${url.hash}`);
    }
    window.requestAnimationFrame(() => {
      target.scrollIntoView({ block: 'start', behavior: 'instant' });
      const heading = target.querySelector('h2, h1') || target;
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    });
  });
})();
